import { createContext, useState, ReactNode } from "react";

export interface SelectedBookContextType {
  bookId: number | null;
  setBookId: (id: number | null) => void;
}

export const SelectedBookContext = createContext<SelectedBookContextType>({
  bookId: null,
  setBookId: () => {},
});

export const SelectedBookProvider = ({ children }: { children: ReactNode }) => {
  const [bookId, setBookId] = useState<number | null>(null);

  return (
    <SelectedBookContext.Provider value={{ bookId, setBookId }}>
      {children}
    </SelectedBookContext.Provider>
  );
};
